
import Component from "vue-class-component"
import Page from "@/report/pages/Page.vue"
import AbstractPage from "@/report/pages/AbstractPage.vue"
import SuperScoreComponentWidget from "@/components/dashboard/SuperScoreComponentWidget.vue"
import {SuperScoreArea} from "@/superscore/SuperScoreArea"
import ProgressBar from "@/components/ProgressBar/ProgressBar.vue"

@Component({
  name: "FitnessActivityPage",
  components: {
    Page,
    SuperScoreComponentWidget,
    ProgressBar,
  },
})
export default class FitnessActivityPage extends AbstractPage {
  SuperScoreArea = SuperScoreArea
}
